import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectProductAndResultType } from '../redux/selectors';
import getDefaultProductType from '../services/productTypeService';
import getDefaultResultType from '../services/resultTypeService';
import { searchParametersSlice } from '../redux/slices';

export default class DefaultHousingType {
  constructor() {
    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
      .subscribe(this.onProductAndResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a default housing type action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.allOptions(payload));
  }

  /**
   * getSearchCommands: Gets the search command property of the default Housing type.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
      homeStatus: null,
    };

    return searchCommandPropertyStructure;
  }

  /**
   * The function updates the product type to apply based on the selected product and result type.
   * @param productAndResultType - It represents the object with the product and result type.
   */
  onProductAndResultTypeChange(productAndResultType) {
    const { resultType, productType} = productAndResultType;
    this.productTypeToApply = getDefaultProductType(productType, resultType);
    this.resultTypeToApply = getDefaultResultType(resultType);
  }
}
